import Cookies from "universal-cookie";

export const VISITOR_ID_COOKIE_NAME = "coff_vid";

/**
 * Thirty days — deliberately shorter than the referral fingerprint's year.
 *
 * This identifier only has to survive the gap between arriving from a campaign
 * and signing up. Once Attribution Binding runs, every later funnel step
 * resolves through the Coffitivity User server-side and the identifier is
 * irrelevant. Thirty days also matches the click window used on the ad platform
 * side, so the two sets of numbers stay comparable.
 *
 * Kept separate from the referral fingerprint on purpose: that one needs a year
 * because its question is "same person, same referrer, ever", and one value
 * cannot serve both lifetimes.
 */
export const VISITOR_ID_MAX_AGE = 60 * 60 * 24 * 30;

/** Read the Visitor's identifier without creating one. */
export function readVisitorId(
	cookieJar: Cookies = new Cookies(),
): string | undefined {
	return cookieJar.get(VISITOR_ID_COOKIE_NAME);
}

/**
 * Get the browser-held attribution identifier, creating it only for a
 * campaign-driven arrival.
 */
export function getOrCreateVisitorId(
	cookieJar: Cookies = new Cookies(),
): string {
	const existing = cookieJar.get(VISITOR_ID_COOKIE_NAME);
	if (existing) return existing;

	const visitorId = crypto.randomUUID();
	cookieJar.set(VISITOR_ID_COOKIE_NAME, visitorId, {
		maxAge: VISITOR_ID_MAX_AGE,
		path: "/",
		sameSite: "lax",
	});
	return visitorId;
}
